
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ImgCaptchaPopup from "./ImgCaptchaPopup.vue";
import { getSmsCodeByMobile, getSmsCodeByforgetPassword } from "@/api/login";
import {
  getSmsCodeByChangeMobile,
  getSmsCodeByBindNewMobile,
  getSmsCodeByChangePassword,
} from "@/api/my";
import { validatePhoneNumber, timeDiff } from "@/utils/util";
import { encryptData } from "@/utils/encryptData";
import dayjs from "dayjs";

// 调用方式  <SendSmsCode :apiUrl="'getSmsCodeByMobileApi'" :mobile="18813926576" />

@Component({
  components: { ImgCaptchaPopup },
})
export default class SendSmsCode extends Vue {
  @Getter sendSmsCodeTimes!: string[];
  @Prop({ default: "发送验证码" }) defaultText!: string; // 默认文本
  @Prop({ default: "getSmsCodeByMobileApi" }) apiUrl: string; // 获取验证码api
  @Prop({ default: "" }) mobile!: string; // 手机号

  apiMap: Record<string, any> = {
    getSmsCodeByMobileApi: getSmsCodeByMobile, // 登录注册获取验证码
    getSmsCodeByforgetPasswordApi: getSmsCodeByforgetPassword, // 忘记密码获取验证码
    getSmsCodeByChangeMobileApi: getSmsCodeByChangeMobile, // 修改手机号获取验证码
    getSmsCodeByBindNewMobileApi: getSmsCodeByBindNewMobile, // 绑定新的手机号获取验证码
    getSmsCodeByChangePasswordApi: getSmsCodeByChangePassword, // 修改密码获取验证码
  };
  showCountDown = false;
  loading = false;
  msgTime = 60000;
  todaySendSmsCodeTimes = []; // 今日发送验证码时间数组

  onClickSend() {
    if (this.showCountDown) return;

    this.sendMsg();
  }

  // verifyCode图片验证码
  async sendMsg(verifyCode?) {
    if (this.loading) return; // 防止loading过程中多次点击

    const apifn = this.apiMap[this.apiUrl];
    if (!this.mobile) {
      this.$toast("请输入手机号");
      return;
    }
    if (!validatePhoneNumber(this.mobile)) {
      // this.$toast("请输入正确的手机号"); // 手机输入框有校验提示，这里重复提示了，去掉
      return;
    }
    if (!apifn) {
      this.$toast("获取验证码出错");
      return;
    }
    // 没有图片验证码，校验验证码发送次数
    if (!verifyCode && !this.checkSendSmsCodeTimes()) {
      return;
    }

    this.loading = true;
    try {
      const res = await apifn({
        mobile: encryptData(this.mobile),
        verifyCode, // 图片验证码
      });
      if (res.code === "000000") {
        setTimeout(() => {
          this.loading = false;
          this.showCountDown = true;
          console.log("msg time start **");
          (this.$refs.countDown as any)?.start();
        }, 2000);
        this.$emit("apiRes", res);
        // 记录本次发送验证码时间
        this.todaySendSmsCodeTimes.push(dayjs().format("YYYY-MM-DD HH:mm:ss"));
        this.$store.commit("setSendSmsCodeTimes", this.todaySendSmsCodeTimes);
      } else {
        this.$toast(res.msg || "获取验证码出错");

        this.showCountDown = false;
        this.loading = false;
        this.$emit("apiRes", res);
      }
    } catch (err) {
      let msg = err.data?.msg
      if(!msg) {
        msg = err.response?.data?.msg
      }
      const showToastTip = err.config?.extraParams?.showToastTip ?? true // 配置接口错误提示显示
      showToastTip && this.$toast(msg || "获取验证码出错");
      this.showCountDown = false;
      this.loading = false;
      this.$emit("apiRes", err);
    }
  }

  // 校验验证码发送次数
  checkSendSmsCodeTimes() {
    this.todaySendSmsCodeTimes = filterTodayTimes(this.sendSmsCodeTimes);
    // 今天内发送验证码超过10次，弹起图片验证码
    if (this.todaySendSmsCodeTimes.length >= 10) {
      (this.$refs.imgCaptchaPopupRef as any).showPopup();
      return false;
    }

    let sendSmsCodeTimesWithin5Minutes = filterWithinMinutes(
      this.todaySendSmsCodeTimes
    );
    // 5分钟内发送验证码超过3次，弹起图片验证码
    if (sendSmsCodeTimesWithin5Minutes.length >= 3) {
      (this.$refs.imgCaptchaPopupRef as any).showPopup();
      return false;
    }

    return true;

    // 过滤得到今天的验证码发送时间
    function filterTodayTimes(times) {
      const today = dayjs().format("YYYY-MM-DD");
      return times.filter((time) => {
        return dayjs(time).format("YYYY-MM-DD") === today;
      });
    }

    // 过滤得到5分钟内的验证码发送时间
    function filterWithinMinutes(times, minutes = 5) {
      const thresholdSeconds = minutes * 60;
      return times.filter((time) => {
        // 计算绝对秒数差值
        const diffSeconds = Math.abs(timeDiff(time, "second"));
        return diffSeconds <= thresholdSeconds;
      });
    }
  }

  onImgCaptchaPopupConfirm(verifyCode) {
    this.sendMsg(verifyCode);
  }

  finish() {
    console.log("msg time finish **");
    this.showCountDown = false;

    (this.$refs.countDown as any)?.reset();
  }

  mounted() {
    (this.$refs.countDown as any)?.reset();
  }
}
